/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Settings_Template_Topic_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Description of topic {position}" |
*
* @param {Settings_Template_Topic_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_topic_description_label = /** @type {((inputs: Settings_Template_Topic_Description_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Topic_Description_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Beschrijving van onderwerp ${i?.position}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Description du sujet ${i?.position}`)
	return /** @type {LocalizedString} */ (`Description of topic ${i?.position}`)
});